<template>
  <attribution platform="android" />
</template>
<script>
import Attribution from '@/modules/attribution/pages/AttributionFormPage'

export default {
  name: 'AttributionAndroid',

  components: { Attribution }
}
</script>



// WEBPACK FOOTER //
// src/modules/attribution/pages/AttributionAndroid.vue